import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

interface DiscardSummaryDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  pending?: boolean;
  onSubmit: (reason: string) => void;
}

/** Forkast utkastet med en grunn (påkrevd). Selve møtet og transkripsjonen berøres ikke. */
export default function DiscardSummaryDialog({ open, onOpenChange, pending, onSubmit }: DiscardSummaryDialogProps) {
  const [reason, setReason] = useState("");
  useEffect(() => {
    if (open) setReason("");
  }, [open]);
  const valid = reason.trim().length > 0;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Forkast referatet</DialogTitle>
          <DialogDescription>Utkastet forkastes og godkjenningskortet i køen lukkes. Du kan lage et nytt fra notater etterpå.</DialogDescription>
        </DialogHeader>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (valid) onSubmit(reason.trim());
          }}
        >
          <div className="space-y-1.5 py-2">
            <Label htmlFor="discard-reason">Grunn</Label>
            <Textarea id="discard-reason" value={reason} onChange={(e) => setReason(e.target.value)} rows={3} autoFocus />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Avbryt
            </Button>
            <Button type="submit" variant="destructive" disabled={!valid || pending}>
              {pending ? "Forkaster ..." : "Forkast referat"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
